export const SUPPORT_EMAIL = {
  TO_ADDRESS: "support@samphire.com",
} as const;
